import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'onefaceui-react-components';

const StopInstructions = ({ stop }) => {
  const stopInstructions = useMemo(() => {
    return stop.get('instructions')
  }, [stop]);

  return (
    <Flex
      shouldShow={stopInstructions}
      alignItems="center"
      className="stop-instructions-item"
    >
      <div>{stopInstructions}</div>
    </Flex>
  );
}

StopInstructions.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stop: PropTypes.object.isRequired
}

export default StopInstructions;
